import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {
	RenameNovaAgentVersionInput,
	RenameNovaAgentVersionMutation,
} from './__generated__/RenameNovaAgentVersionMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

// The caller (NovaStudioPage.tsx) follows a successful rename with its own on-demand detail refetch to
// bring the version list forward. The response carries each version's content hash, which the rename
// moved, for the editor's next save in place.
const mutation = graphql`
	mutation RenameNovaAgentVersionMutation($input: RenameNovaAgentVersionInput!) {
		renameNovaAgentVersion(input: $input) {
			agent {
				id
				versions {
					versionNumber
					contentHash
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<RenameNovaAgentVersionInput>,
	onSuccess?: RelayOnCompleted<RenameNovaAgentVersionMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation<RenameNovaAgentVersionMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
